/* eslint-disable prettier/prettier */
import { IoIosAdd } from 'react-icons/io';
import Button from 'components/Buttons/Button';
import { Form } from 'formik';
import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import BaseField from 'components/Field';

interface StyledProps {
  marginBottom?: boolean;
}

export const Wrapper = styled.div`
  @media ${({ theme }) => theme.device.mobile} {
    height: 100vh;
  }
`;

export const FormContainer = styled(Form)<StyledProps>`
  margin-bottom: ${({ marginBottom }) => marginBottom && '100px'};
  overflow-x: hidden;
`;

export const Container = styled.section`
  height: auto;

  @media ${({ theme }) => theme.device.mobile} {
    background-color: ${ColorPalette.HEX.Lotion};
    min-height: 100vh;
  }

  @media ${({ theme }) => theme.device.desktop} {
    max-width: 1300px;
  }
`;

export const Line = styled.div`
  width: 100%;
  padding-top: 32px;
  height: 1px;
  border-bottom: solid 1px ${ColorPalette.HEX.BrightGray};

  @media ${({ theme }) => theme.device.mobile} {
    margin-left: -16px;
    width: calc(100% + 32px);
  }
`;

export const Field = styled(BaseField)`
  margin-bottom: 16px;
`;

export const CloseButton = styled.button`
  display: flex;
  cursor: pointer;
  background: none;
`;

export const CloseIcon = styled(IoIosAdd)`
  font-size: 30px;
  transform: rotate(45deg);
`;

export const SectionDateOfBirth = styled.section`
  padding: 0px 0 48px 0;
  margin-top: -18px;

  @media ${({ theme }) => theme.device.desktop} {
    display: grid;
    grid-template-columns: 1fr 2fr;
    grid-gap: 32px;

    padding-left: 0;
    padding-right: 0;
  }

  @media ${({ theme }) => theme.device.mobile} {
    padding: 0px 16px 32px 16px;
    margin-top: -20px;
  }
`;

export const Content = styled.div`
  @media ${({ theme }) => theme.device.desktop} {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 5px;
  }
`;

export const ErrorValidation = styled.span`
  padding-top: 4px;
  font-size: 12px;
  color: ${({ theme }) => theme.primaryBackgroundColor};
`;

export const SearchButtonContainer = styled.div`
  position: fixed;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
  bottom: 32px;
  right: 32px;

  @media ${({ theme }) => theme.device.mobile} {
    position: fixed;
    left: 0;
    bottom: 0px;
    right: 0;
    width: 100%;
    margin-bottom: 32px;
  }
`;

export const SearchButton = styled(Button)`
  height: auto;
  min-height: 55px;
  font-size: 16px;
  line-height: initial;
  padding: 14px;
  margin-top: 16px;
  margin-left: auto;

  @media ${({ theme }) => theme.device.mobile} {
    margin: 28px 16px 0px;
    width: 100%;
  }
`;
